import React from 'react'
import moment from "moment";
let SERVER_URL = process.env.REACT_APP_API_URL;
let BASE_URL = process.env.REACT_APP_APP_URL;

function TotalcountinoutInAday({ userId, att_date, moreinout }) {
    // console.log('moreinout :', moreinout)


    function calculateHourse(timeIn, timeOut, startDate, endDate) {


        const createdDate = moment(startDate).format('YYYY-MM-DD');
        const updatedDate = moment(endDate).format('YYYY-MM-DD');


        var intime = new Date(createdDate + ' ' + timeIn);
        var outtime = new Date(updatedDate + ' ' + timeOut);

        // console.log('difference in ms', date1 - date2);

        // Use Math.abs() so the order of the dates can be ignored and you won't
        // end up with negative numbers when date1 is before date2.
        // console.log('difference in ms abs', Math.abs(date1 - date2));
        // console.log('difference in seconds', Math.abs(date1 - date2) / 1000);

        var diffInSeconds = Math.abs(intime - outtime) / 1000;
        var days = Math.floor(diffInSeconds / 60 / 60 / 24);
        var hours = Math.floor(diffInSeconds / 60 / 60 % 24);
        var minutes = Math.floor(diffInSeconds / 60 % 60);
        var seconds = Math.floor(diffInSeconds % 60);
        var milliseconds = Math.round((diffInSeconds - Math.floor(diffInSeconds)) * 1000);

        // console.log('days', days);
        // console.log('hours', ('0' + hours).slice(-2));
        // console.log('minutes', ('0' + minutes).slice(-2));
        // console.log('seconds', ('0' + seconds).slice(-2));
        // console.log('milliseconds', ('00' + milliseconds).slice(-3));


        return ('0' + hours).slice(-2) + ':' + ('0' + minutes).slice(-2)
        // var startTime11 = moment(timeIn, 'hh:mm:ss a');
        // var endTime11 = moment(timeOut, 'hh:mm:ss a');


        // const startTime1 = moment(startDate).format('YYYY/MM/DD');
        // const endTime1 = moment(endDate).format('YYYY/MM/DD');

        // console.log('startDate', startTime1) // 4
        // console.log('endDate', endTime1) // 4

        // const startTime1 = moment().format(startDate + ' ' + timeIn, 'YYYY/MM/DD HH:mm');
        // const endTime1 = moment().format(endDate + ' ' + endDate, 'YYYY/MM/DD HH:mm');





        // const hoursDiff = endTime1+' '+endTime11.diff(startTime1+' '+startTime11, 'hours', true);
        // let start_time = moment().format('2024:12:02 '+timeIn);
        // let next_time = moment().format('2024:12:03 '+timeOut);

        // console.log('start_time :',start_time)
        // console.log('next_time :',next_time)
        // let diff_milliseconds = Date.parse(next_time) - Date.parse(start_time);
        // let diff_seconds = diff_milliseconds * 1000;
        // console.log('diff_seconds :',diff_seconds)

        // var a = moment('2016-06-06T21:03:55');//now
        // var b = moment('2016-05-06T20:03:55');
        // console.log(a.diff(b, 'minutes')) // 44700
        // console.log(a.diff(b, 'hours')) // 745
        // console.log(a.diff(b, 'days')) // 31
        // console.log(a.diff(b, 'weeks')) // 4
        // console.log('startDate', startTime1) // 4
        // console.log('endDate', endTime1) // 4



        // console.log(hoursDiff); // 1.5


        var startTime = moment(timeIn, 'hh:mm:ss a');
        var endTime = moment(timeOut, 'hh:mm:ss a');

        var totalHours = (endTime.diff(startTime, 'hours'));
        var totalMinutes = endTime.diff(startTime, 'minutes');
        var clearMinutes = totalMinutes % 60;
        var minutformat = parseInt(clearMinutes) < 10 ? '0' + clearMinutes : clearMinutes;
        var totalHoursformat = parseInt(totalHours) < 10 ? '0' + totalHours : totalHours;
        // return (totalHoursformat + " : " + minutformat);
    }
    return (
        <div>
            <table className='table_style_2'>
                <thead>
                    <tr>
                        <th>Start Time</th>
                        <th>Stop Time</th>
                        <th>Total Hours</th>
                    </tr>
                </thead>
                <tbody>
                    {
                        moreinout.map((item) => {
                            return <tr><td>{moment(item.start_time, 'HH:mm').format('hh:mm a').toUpperCase()}</td><td>{item.end_time != '00:00:00' && moment(item.end_time, 'HH:mm').format('hh:mm a').toUpperCase()}</td><td>{(item.end_time != '00:00:00') && calculateHourse(item.start_time, item.end_time, item.att_date, item.updated_on) + ' HRS'}</td></tr>
                        })
                    }
                </tbody>
            </table>
        </div>
    )
}
export default TotalcountinoutInAday
